<template>
  <div>
    <van-nav-bar @click-left="onClickLeft" left-arrow class="nav_bar" :fixed="true">
      <!-- <img class="nav_bar_right" src="@/assets/images/x2-01.png" @click="popupShare" slot="right" /> -->
    </van-nav-bar>
    <div class="popup_share">
      <van-popup v-model="popupShareVisible" position="bottom" :style="{ height: '43%' }">
        <van-divider
          class="phone_title"
          :style="{ color: '#595757', borderColor: '#C9CACA'}"
        >把活动推荐给好友</van-divider>
        <van-grid :column-num="5" :border="false">
          <van-grid-item @click="wechatSessionClick">
            <div>
              <img src="@/assets/images/popups/weixin.png" alt />
            </div>
            <div class="popup_text">微信好友</div>
          </van-grid-item>
          <van-grid-item @click="wechatTimeLineClick">
            <div>
              <img src="@/assets/images/popups/friends.png" alt />
            </div>
            <div class="popup_text">朋友圈</div>
          </van-grid-item>
          <van-grid-item @click="qqClick">
            <div>
              <img src="@/assets/images/popups/qq.png" alt />
            </div>
            <div class="popup_text">QQ</div>
          </van-grid-item>
          <van-grid-item @click="qzoneClick">
            <div>
              <img src="@/assets/images/popups/qqspace.png" alt />
            </div>
            <div class="popup_text">QQ空间</div>
          </van-grid-item>
          <van-grid-item @click="microblog">
            <div>
              <img src="@/assets/images/popups/weibo.png" alt />
            </div>
            <div class="popup_text">新浪微博</div>
          </van-grid-item>
          <van-grid-item @click="copyClick">
            <div>
              <img src="@/assets/images/popups/file.png" alt />
            </div>
            <div class="popup_text">复制</div>
          </van-grid-item>
        </van-grid>
        <div @click="btnCancel" class="btn_cancel">取消</div>
      </van-popup>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      popupShareVisible: false
    }
  },
  props: {
    id: {
      type: String
    }
  },
  methods: {
    // btnCancel分享取消
    btnCancel() {
      this.popupShareVisible = false
    },
    // 分享点击
    // 微博
    microblog() {
      const shareUrl =
        '${FRONTEND_HOST}/detailspage/shophome/index?id=' + this.id + ''
      console.log(shareUrl)

      this.$callApp('Android', 'ShareToSinaMethod', shareUrl)
      this.$callApp('iOS', 'ShareToSinaMethod', shareUrl)
      this.popupShareVisible = false
    },
    // QQ
    qqClick() {
      const shareUrl =
        '${FRONTEND_HOST}/detailspage/shophome/index?id=' + this.id + ''
      this.$callApp('Android', 'ShareToQQMethod', shareUrl)
      this.$callApp('iOS', 'ShareToQQMethod', shareUrl)
      this.popupShareVisible = false
    },
    // QQ空间
    qzoneClick() {
      const shareUrl =
        '${FRONTEND_HOST}/detailspage/shophome/index?id=' + this.id + ''
      this.$callApp('Android', 'ShareToQzoneMethod', shareUrl)
      this.$callApp('iOS', 'ShareToQzoneMethod', shareUrl)
      this.popupShareVisible = false
    },
    // 微信
    wechatSessionClick() {
      const shareUrl =
        '${FRONTEND_HOST}/detailspage/shophome/index?id=' + this.id + ''
      this.$callApp('Android', 'ShareToWechatSessionMethod', shareUrl)
      this.$callApp('iOS', 'ShareToWechatSessionMethod', shareUrl)
      this.popupShareVisible = false
    },
    // 微信朋友圈
    wechatTimeLineClick() {
      const shareUrl =
        '${FRONTEND_HOST}/detailspage/shophome/index?id=' + this.id + ''
      this.$callApp('Android', 'ShareToWechatTimeLineMethod', shareUrl)
      this.$callApp('iOS', 'ShareToWechatTimeLineMethod', shareUrl)
      this.popupShareVisible = false
    },
    // 复制
    copyClick() {
      const shareUrl =
        '${FRONTEND_HOST}/detailspage/shophome/index?id=' + this.id + ''
      this.$callApp('Android', 'CopyMethod', shareUrl)
      this.$callApp('iOS', 'CopyMethod', shareUrl)
      this.popupShareVisible = false
    },
    onClickLeft() {
      // this.$router.back(-1);
      if (this.$getIsApp()) {
        this.$callApp('Android', 'GoBackAppMethod', '')
        this.$callApp('iOS', 'GoBackAppMethod', '')
      } else {
        this.$router.back(-1)
      }
    },
    popupShare() {
      this.popupShareVisible = !this.popupShareVisible
    }
  }
}
</script>

<style lang="less" scoped>
.van-nav-bar {
  width: 375px;
  height: 44.5px;
  line-height: 44.5px;
}
.nav_bar {
  /deep/ .van-icon {
    color: black;
    font-size: 18px;
  }
  z-index: 99991 !important;
  .nav_bar_right {
    width: 25px;
    height: 25px;
    margin: -7px 7.5px;
  }
}

//分享弹框
.popup_share {
  .phone_title {
    padding: 0 8px;
    font-size: 15px;
    text-align: center;
    margin: 20px 0 22.5px 0;
  }
  img {
    width: 50px;
    height: 50px;
  }
  .popup_text {
    margin-top: 7.5px;
    font-size: 12px;
    color: #595757;
  }
  .btn_cancel {
    margin-top: 5px;
    border-top: 1px solid #c9caca;
    line-height: 44.5px;
    height: 44.5px;
    text-align: center;
    font-size: 15px;
    color: #231815;
  }
}
</style>
